var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9H9V18H10.5V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9H13.5V18H15V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5V6H4.5V21C4.5 21.3978 4.65804 21.7794 4.93934 22.0607C5.22064 22.342 5.60218 22.5 6 22.5H18C18.3978 22.5 18.7794 22.342 19.0607 22.0607C19.342 21.7794 19.5 21.3978 19.5 21V6H21V4.5H3ZM6 21V6H18V21H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H9V3H15V1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteOptions);
export default __webpack_public_path__ + "static/media/ic-delete-options.0660e4bee6110cab4dea4bf5e880583d.svg";
export { ForwardRef as ReactComponent };